/** Animated fit when search/filter refines the graph (not first load). */
export const KG_GRAPH_REFINE_FIT_PADDING = 0.14;
export const KG_GRAPH_REFINE_FIT_DURATION_MS = 450;
export const KG_GRAPH_REFINE_FIT_MAX_ZOOM = 1;

/** Inspector linked-row → canvas focus (gentler than single-node tight fit). */
export const KG_INSPECTOR_FOCUS_PADDING = 0.34;
export const KG_INSPECTOR_FOCUS_DURATION_MS = 1300;
export const KG_INSPECTOR_FOCUS_MAX_ZOOM = 0.9;
